module.exports = __webpack_public_path__ + "img/icon_5_4.574f7fe3.png";